import {
  defaultLocale,
  getDirection,
  isLocale,
  type Locale,
  localeStorageKey,
  resolveLocale,
} from './locale';

let currentLocale: Locale = defaultLocale;
const listeners = new Set<() => void>();
let initialized = false;
export const getLocale = () => currentLocale;
export const subscribeLocale = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const applyLocale = (locale: Locale) => {
  currentLocale = locale;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
    document.documentElement.dir = getDirection(locale);
  }
  for (const listener of listeners) {
    listener();
  }
};
export const setLocale = (locale: Locale) => {
  if (!isLocale(locale)) {
    return;
  }
  try {
    localStorage.setItem(localeStorageKey, locale);
  } catch {
    /* Private browsing can disable storage. */
  }
  applyLocale(locale);
};
export const initializeBrowserLocale = () => {
  if (initialized || typeof window === 'undefined') {
    return currentLocale;
  }
  initialized = true;
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(localeStorageKey);
  } catch {
    /* Use browser preferences. */
  }
  applyLocale(isLocale(saved) ? saved : resolveLocale(navigator.languages));
  window.addEventListener('storage', (event) => {
    if (event.key === localeStorageKey || event.key === null) {
      applyLocale(isLocale(event.newValue) ? event.newValue : resolveLocale(navigator.languages));
    }
  });
  return currentLocale;
};
export const localeHeaders = () => ({ 'Accept-Language': getLocale() });
